export const FETCH_FAVORITES = 'FETCH_FAVORITES';
export const FETCH_FAVORITES_SUCCESS = 'FETCH_FAVORITES_SUCCESS';
export const FETCH_FAVORITES_ERROR = 'FETCH_FAVORITES_ERROR';

export const FAVORITE_STYLE = 'FAVORITE_STYLE';
export const FAVORITE_STYLE_SUCCESS = 'FAVORITE_STYLE_SUCCESS';
export const FAVORITE_STYLE_ERROR = 'FAVORITE_STYLE_ERROR';

export const UNFAVORITE_STYLE = 'UNFAVORITE_STYLE';
export const UNFAVORITE_STYLE_SUCCESS = 'UNFAVORITE_STYLE_SUCCESS';
export const UNFAVORITE_STYLE_ERROR = 'UNFAVORITE_STYLE_ERROR';

export function fetchFavorites() {
    return {
        type: FETCH_FAVORITES
    };
}

/**
 * Favorite styles successfully pulled from the service.  This
 *  action will instruct the reducer to save the styles into the
 * @param styles Dictionary of stylenumber => ... something??
 * @returns {{type: string, payload: {styles: *}}}
 */
export function fetchFavoritesSuccess(styles) {
    return {
        type: FETCH_FAVORITES_SUCCESS,
        payload: {
            styles: styles
        }
    };
}

/**
 * Favorite styles failed to fetch
 * @param error
 * @returns {{type: string, payload: {error: *}}}
 */
export function fetchFavoritesError(error) {
    return {
        type: FETCH_FAVORITES_ERROR,
        payload: {
            error: error
        }
    };
}

/**
 * User favorites a particular style number
 * @param styleNumber Style number of the product being favorited
 */
export function favoriteStyle(styleNumber, displayName, component = {}) {
    return {
        type: FAVORITE_STYLE,
        meta: {
            component: component
        },
        payload: {
            styleNumber: styleNumber,
            displayName: displayName
        }
    };
}

export function favoriteStyleSuccess(styleNumber, component = {}) {
    return {
        type: FAVORITE_STYLE_SUCCESS,
        meta: {
            component: component
        },
        payload: {
            styleNumber: styleNumber
        }
    };
}

export function favoriteStyleError(error) {
    return {
        type: FAVORITE_STYLE_ERROR,
        payload: {
            error: error
        }
    };
}

export function unfavoriteStyle(styleNumber, displayName, component) {
    return {
        type: UNFAVORITE_STYLE,
        meta: {
            component: component
        },
        payload: {
            styleNumber: styleNumber,
            displayName: displayName
        }
    };
}

export function unfavoriteStyleSuccess(styleNumber, component) {
    return {
        type: UNFAVORITE_STYLE_SUCCESS,
        meta: {
            component: component
        },
        payload: {
            styleNumber: styleNumber
        }
    };
}

export function unfavoriteStyleError(error) {
    return {
        type: UNFAVORITE_STYLE_ERROR,
        payload: {
            error: error
        }
    };
}
